import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-4b5bba96")
const _hoisted_1 = { class: "p-pt-3 h100" }
const _hoisted_2 = ["onDblclick"]
const _hoisted_3 = ["id"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", null, "Disponible", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "avatar" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "name" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrgChart = _resolveComponent("OrgChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_OrgChart, {
      value: _ctx.rootNode,
      collapsible: true
    }, {
      person: _withCtx(({ node: { data, key} }) => [
        _createElementVNode("div", {
          class: _normalizeClass(["node-header ui-corner-top", { clickable: _ctx.editMode }]),
          onDblclick: ($event: any) => (_ctx.nodeClicked(data))
        }, _toDisplayString(data?.name), 43, _hoisted_2),
        _createElementVNode("table", {
          class: "node-content",
          id: key
        }, [
          (!data.people.length)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_4, _hoisted_6))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.people, (person) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: person._id
            }, [
              _createElementVNode("td", _hoisted_7, [
                (person.avatar)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: person.avatar,
                      alt: person.name
                    }, null, 8, _hoisted_8))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _ctx.unknown,
                      alt: person.name
                    }, null, 8, _hoisted_9))
              ]),
              _createElementVNode("td", _hoisted_10, _toDisplayString(person.name), 1)
            ]))
          }), 128))
        ], 8, _hoisted_3)
      ]),
      default: _withCtx(({ node: { data } }) => [
        _createElementVNode("span", null, _toDisplayString(data?.name), 1)
      ]),
      _: 1
    }, 8, ["value"])
  ]))
}